/* eslint-disable camelcase */
import React from 'react'
import { Grid, TextField, MenuItem } from '@material-ui/core'
import ReactInputMask from 'react-input-mask'

const FormTakerData = ({
  nfseCompanies,
  form,
  mask,
  cpfCnpj,
  handleChange = () => {},
  handleChangeCpf = () => {},
  handleValidCpfCnpj = () => {},
  handlePasteCpf = () => {},
}) => {
  return (
    <>
      {nfseCompanies?.length > 0 && (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4}>
              <TextField
                select
                value={form?.company_id}
                name="company_id"
                required
                variant="standard"
                fullWidth
                label="Compania"
                onChange={handleChange}
              >
                <MenuItem value="">Selecione...</MenuItem>
                {nfseCompanies?.map((company, index) => (
                  <MenuItem value={company?.id} index={index}>
                    {company?.company_name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid item xs={4}>
        <TextField
          name="client_name"
          value={form.client_name}
          onChange={handleChange}
          label="Nome do Tomador"
          required
          fullWidth
        />
      </Grid>

      <Grid item xs={4}>
        <ReactInputMask
          mask={mask}
          maskChar=""
          name="cpf_cnpj"
          value={form?.cpf_cnpj}
          onChange={e => handleChangeCpf(e)}
          onPaste={handlePasteCpf}
          onBlur={e => handleValidCpfCnpj(e)}
          required
        >
          {inputProps => (
            <TextField
              {...inputProps}
              label="CPF/CNPJ"
              fullWidth
              error={cpfCnpj?.error}
              helperText={cpfCnpj?.text}
            />
          )}
        </ReactInputMask>
      </Grid>
    </>
  )
}

export default FormTakerData
